import { ezsServiceIds, idfServiceIds } from "../../config/UserServicesList";

const monitoringServiceList = [
    ezsServiceIds.creditMonitoring,
    ezsServiceIds.darkWebMonitoring,
    ezsServiceIds.darkWebPhiBot,
    ezsServiceIds.socialMediaMonitoring,
    ezsServiceIds.oneBureauCreditMonitoring,
    ezsServiceIds.tuEnhancedCreditAlerts,
    ezsServiceIds.tuOneBureauCreditMonitoring,
    ezsServiceIds.tuOneBureauCreditMonitoringBasic,
    ezsServiceIds.paydayLoansMonitoring,
    ezsServiceIds.publicRecordsMonitoring,
    ezsServiceIds.courtRecordsMonitoring,
    ezsServiceIds.changeOfAddressMonitoring,
    ezsServiceIds.basicPublicRecordsMonitoring,
    ezsServiceIds.tuCriminalMonitoring,
    ezsServiceIds.tuIDPMonitoring,
    ezsServiceIds.sexOffenderMonitoring,
    ezsServiceIds.paydayLoansMonitoring,
    ezsServiceIds.smartSSNTrackerAdult,
    ezsServiceIds.smartSSNTrackerChild,
    ezsServiceIds.threeBureauCreditMonitoring,
    ezsServiceIds.tuThreeBureauCreditMonitoring,
    ezsServiceIds.tuThreeBureauCreditMonitoringBasic,
    ezsServiceIds.financialAccountMonitoring,
    ezsServiceIds.financialTransactionMonitoringMX,
    ezsServiceIds.tuAdvancedFraudMonitoring,
    ezsServiceIds.tuChangeOfAddressMonitoring,
    ezsServiceIds.tuSSNMonitoring,
    ezsServiceIds.tuCanadaCreditMonitoring,
];

const businessMonitoringServiceList = [ezsServiceIds.businessDarkWebMonitoring, idfServiceIds.businessCreditMonitoring];

const idfMonitoringServiceList = [
    idfServiceIds.payDayLoanMonitoring,
    idfServiceIds.paydayLoanMonitoring,
    idfServiceIds.sexOffenderMonitoring,
    idfServiceIds.courtRecordsMonitoring,
    idfServiceIds.changeOfAddressMonitoring,
    idfServiceIds.publicRecordMonitoring,
    idfServiceIds.bankAccountMonitoring,
    idfServiceIds.creditCardMonitoring,
    idfServiceIds.driversLicenseMonitoring,
    idfServiceIds.emailAddressMonitoring,
    idfServiceIds.IBANMonitoring,
    idfServiceIds.medicalAccountMonitoring,
    idfServiceIds.mothersMaidenNameMonitoring,
    idfServiceIds.nationalIdMonitoring,
    idfServiceIds.phoneNumberMonitoring,
    idfServiceIds.passportMonitoring,
    idfServiceIds.addressMonitoring,
    idfServiceIds.ssnMonitoring,
    idfServiceIds.advancedFraudMonitoring,
    idfServiceIds.smartSSNTracker,
    idfServiceIds.childCreditActivityMonitoring,
    idfServiceIds.bankAndCreditCardActivity,
    idfServiceIds.socialMediaMonitoring,
    idfServiceIds.shortTermLoanMonitoring,
];

export { monitoringServiceList, idfMonitoringServiceList, businessMonitoringServiceList };
